module.exports = __webpack_public_path__ + "img/Michael.Leslie.e3ff19ab.jpg";